<template>
  <el-dialog
    append-to-body=""
    title="产品码生产"
    :visible.sync="visible"
    width="360px"
    @close="handleClose">
    <el-form
      ref="ruleForm"
      v-loading="loading"
      :model="produceInfo"
      :rules="rules"
      label-width="90px">
      <el-form-item
        label="生产数量:"
        prop="tagCount">
        <el-input-number
          v-model="produceInfo.tagCount"
          style="width:220px"
          :min="1"
          :max="200000"
          :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item
        label="产品线:"
        prop="productLineNo">
        <vendor-series-radio v-model="produceInfo.productLineNo" />
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="addtagsegment">确 定</el-button>
    </template>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
import VendorSeriesRadio from '../../../components/business/vendor-series-radio.vue'

export default {
  name: 'LabelTagProduceModal',
  components: { VendorSeriesRadio },
  props: {
    fetch: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      produceInfo: {
        tagCount: undefined,
        productLineNo: null
      },
      rules: {
        tagCount: [
          { required: true, message: '请输入生产数量', trigger: 'blur' }
        ],
        productLineNo: [
          { required: true, message: '请选择产品线', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    init() {
      this.toggleModal(true)
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.$refs.ruleForm.resetFields()
      this.produceInfo = {
        tagCount: undefined,
        productLineNo: null
      }
    },
    addtagsegment() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('label/addtagsegment', {
            payload: {
              ...this.produceInfo,
              isPreassign: 1,
              refVendorId: this.userInfo.orgId,
              tagType: this.userDetail.tagTypes
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.fetch && this.fetch()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
